import VoiceSelectorModalBase from "@/components/modal/voice-selector/base/voice-selector-modal-base";
import DefaultVoiceSelector from "@/components/common/voice-selector/selectors/default-voice-selector";

const DefaultVoiceSelectorModal = () => {
  return (
    <VoiceSelectorModalBase>
      <DefaultVoiceSelector />
    </VoiceSelectorModalBase>
  );
};

export default DefaultVoiceSelectorModal;
